import { Change } from '@ui/components/Amount/Change';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';
import { Text } from '@ui/lib/park/ui/text';
import BigNumber from 'bignumber.js';
import { useTranslation } from 'next-i18next';

import { GenericTradeParams } from '../../../types';

export const StopLossChange = ({
  genericTradeParams,
  toStopLossPrice,
}: {
  toStopLossPrice: BigNumber;
} & GenericTradeParams) => {
  const { t } = useTranslation();
  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams?.pair.baseSymbol,
    genericTradeParams?.pair.priceDisplayDecimals,
  );

  if (toStopLossPrice.isZero() && genericTradeParams.stopLoss.isZero())
    return (
      <Text
        textStyle="v2.label"
        color="v2.text.secondary"
        textAlign="right"
      >
        {t('common.Not Set')}
      </Text>
    );

  return (
    <Change
      containerDataCy="StopLossChange"
      nextValue={toStopLossPrice}
      prevValue={genericTradeParams.stopLoss}
      opts={{
        prefix: '$',
        displayDecimals: priceDisplayDecimals,
        saveDecimalsMode: true,
      }}
      notSetCheck={(nextValue) => {
        if (nextValue.isZero()) {
          return (
            <Text textStyle="v2.label" color="v2.text.secondary">
              {t('common.Not Set')}
            </Text>
          );
        }
      }}
    />
  );
};

export const TakeProfitChange = ({
  genericTradeParams,
  toTakeProfitPrice,
}: {
  toTakeProfitPrice: BigNumber;
} & GenericTradeParams) => {
  const { t } = useTranslation();
  const priceDisplayDecimals = useTokenDisplayDecimals(
    genericTradeParams?.pair.baseSymbol,
    genericTradeParams?.pair.priceDisplayDecimals,
  );

  if (toTakeProfitPrice.isZero() && genericTradeParams.takeProfit.isZero())
    return (
      <Text
        textStyle="v2.label"
        color="v2.text.secondary"
        textAlign="right"
      >
        {t('common.Not Set')}
      </Text>
    );

  return (
    <Change
      containerDataCy="TakeProfitChange"
      nextValue={toTakeProfitPrice}
      prevValue={genericTradeParams.takeProfit}
      opts={{
        prefix: '$',
        displayDecimals: priceDisplayDecimals,
      }}
      notSetCheck={(nextValue) => {
        if (nextValue.isZero()) {
          return (
            <Text textStyle="v2.label" color="v2.text.secondary">
              {t('common.Not Set')}
            </Text>
          );
        }
      }}
    />
  );
};
